import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/*
! to override the default style pass classes and use !important with the property you want to override
! e.g. classes={{ buttonStyle: { backgroundColor: "red !important" } }}
*/
const useStyles = makeStyles((theme) => ({
  whiteButtonStyle: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    fontFamily: "Inter",
    backgroundColor: theme.palette.background.studentProgressBg,
    color: theme.palette.secondaryBtnTxt,
    paddingTop: "11.5px",
    paddingBottom: "11.5px",
    paddingLeft: "8px",
    paddingRight: "8px",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "600",
    cursor: "pointer",
    justifyContent: "center",
    gap: "8px",
    border: theme.palette.ternaryBtnBdr,
    "&:hover:not([disabled])": {
      backgroundColor: theme.palette.secondaryBtnHover,
    },
    "&[disabled]": {
      cursor: "not-allowed",
      opacity: 0.6,
      backgroundColor: "#C0C0C0",
      color: theme.palette.newHeading,
    },
  },
  buttonStyle: {
    width: "100%",
    height: "100%",
    fontFamily: "Inter",
    backgroundColor: "#FFC62E",
    color: theme.palette.primaryBtnTxt,
    paddingTop: "11.5px",
    paddingBottom: "11.5px",
    paddingLeft: "8px",
    paddingRight: "8px",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "background-color 0.2s ease-in-out, opacity 0.2s ease-in-out",
    outline: "none",
    "&:hover:not([disabled])": {
      backgroundColor: "#FFB300",
    },
    "&[disabled]": {
      cursor: "not-allowed",
      opacity: 0.6,
      backgroundColor: "#FFC62E",
    },
  },
  redButtonStyle: {
    backgroundColor: "#F56565",
    color: "#FFFFFF",
    "&:hover:not([disabled])": {
      backgroundColor: "#E53E3E",
    },
    display: "flex",
    alignItems: "center",
    width: "100%",
    fontFamily: "Inter",
    paddingTop: "11.5px",
    paddingBottom: "11.5px",
    paddingLeft: "8px",
    paddingRight: "8px",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "600",
    cursor: "pointer",
    justifyContent: "center",
    border: "none",
    gap: "8px",
    "&[disabled]": {
      cursor: "not-allowed",
      opacity: 0.6,
      backgroundColor: "#C0C0C0",
      color: theme.palette.newHeading,
    },
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    // color: "#614600",
    lineHeight: "100%",
  },
  startIcon: {
    height: "15px",
    width: "15px",
  },
  endIcon: {
    height: "15px",
    width: "15px",
  },
}));

const CustomStyledButton = ({
  children,
  onClick,
  startIcon,
  endIcon,
  classes = {},
  disabled = false,
  type = "default",
  buttonType = "button", // New prop for HTML button type
  ...otherProps
}) => {
  const defaultStyles = useStyles();
  return (
    <button
      type={buttonType}
      onClick={!disabled ? onClick : undefined}
      className={`${
        type === "white"
          ? defaultStyles.whiteButtonStyle
          : type === "red"
          ? defaultStyles.redButtonStyle
          : defaultStyles.buttonStyle
      } ${classes.buttonStyle} `}
      disabled={disabled}
      {...otherProps}
    >
      {startIcon && (
        <span className={`${classes.startIcon} ${defaultStyles.startIcon}`}>
          {startIcon}
        </span>
      )}
      <span className={`${classes.label} ${defaultStyles.label}`}>
        {children}
      </span>
      {endIcon && (
        <span className={`${classes.endIcon} ${defaultStyles.endIcon}`}>
          {endIcon}
        </span>
      )}
    </button>
  );
};

export default CustomStyledButton;
